import TimelineSegment from "security-app/components/Investigations/Details/TimelineSegment/TimelineSegment";
export default TimelineSegment;
